import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_5c8df442 from 'nuxt_plugin_sentryserver_5c8df442' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_6bff9457 from 'nuxt_plugin_sentryclient_6bff9457' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_62348685 from 'nuxt_plugin_plugin_62348685' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_portalvue_1417d418 from 'nuxt_plugin_portalvue_1417d418' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_templatesplugin5762e1e4_ac87bedc from 'nuxt_plugin_templatesplugin5762e1e4_ac87bedc' // Source: ./templates.plugin.5762e1e4.js (mode: 'client')
import nuxt_plugin_gtm_526e3a9e from 'nuxt_plugin_gtm_526e3a9e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_recaptcha_61491a0a from 'nuxt_plugin_recaptcha_61491a0a' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_76d29ac3 from 'nuxt_plugin_cookieuniversalnuxt_76d29ac3' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_dayjsplugin_3576e362 from 'nuxt_plugin_dayjsplugin_3576e362' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_6d0cd680 from 'nuxt_plugin_pluginutils_6d0cd680' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_1331c3cb from 'nuxt_plugin_pluginrouting_1331c3cb' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_5ee898f8 from 'nuxt_plugin_pluginmain_5ee898f8' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_ad9eddca from 'nuxt_plugin_axios_ad9eddca' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moduleplugin3f4c7f02_60e2780e from 'nuxt_plugin_moduleplugin3f4c7f02_60e2780e' // Source: ./module.plugin.3f4c7f02.mjs (mode: 'all')
import nuxt_plugin_klaviyoevents_593d8433 from 'nuxt_plugin_klaviyoevents_593d8433' // Source: ../plugins/klaviyo-events (mode: 'all')
import nuxt_plugin_googleanalyticsevents_5d1e23c4 from 'nuxt_plugin_googleanalyticsevents_5d1e23c4' // Source: ../plugins/google-analytics-events (mode: 'all')
import nuxt_plugin_gtmevents_3d4af65c from 'nuxt_plugin_gtmevents_3d4af65c' // Source: ../plugins/gtm-events (mode: 'all')
import nuxt_plugin_fbevents_46c91c94 from 'nuxt_plugin_fbevents_46c91c94' // Source: ../plugins/fb-events (mode: 'all')
import nuxt_plugin_imgplaceholder_7a19279a from 'nuxt_plugin_imgplaceholder_7a19279a' // Source: ../plugins/img-placeholder (mode: 'all')
import nuxt_plugin_lazyload_af447860 from 'nuxt_plugin_lazyload_af447860' // Source: ../plugins/lazyload (mode: 'all')
import nuxt_plugin_index_6c73db4f from 'nuxt_plugin_index_6c73db4f' // Source: ../plugins/storyblok/index.js (mode: 'all')
import nuxt_plugin_components_fa5dd412 from 'nuxt_plugin_components_fa5dd412' // Source: ../plugins/storyblok/components.js (mode: 'all')
import nuxt_plugin_shopify_62048410 from 'nuxt_plugin_shopify_62048410' // Source: ../plugins/shopify (mode: 'all')
import nuxt_plugin_vuelidate_4345260a from 'nuxt_plugin_vuelidate_4345260a' // Source: ../plugins/vuelidate (mode: 'all')
import nuxt_plugin_googlemaps_ab35f716 from 'nuxt_plugin_googlemaps_ab35f716' // Source: ../plugins/google-maps (mode: 'all')
import nuxt_plugin_googleapi_2ec9487c from 'nuxt_plugin_googleapi_2ec9487c' // Source: ../plugins/google-api (mode: 'all')
import nuxt_plugin_location_6466e52b from 'nuxt_plugin_location_6466e52b' // Source: ../plugins/location (mode: 'all')
import nuxt_plugin_customsentry_4a274bf6 from 'nuxt_plugin_customsentry_4a274bf6' // Source: ../plugins/custom-sentry (mode: 'all')
import nuxt_plugin_searchspring_c00bb7aa from 'nuxt_plugin_searchspring_c00bb7aa' // Source: ../plugins/searchspring (mode: 'all')
import nuxt_plugin_redisclient_703602d3 from 'nuxt_plugin_redisclient_703602d3' // Source: ../plugins/redis-client (mode: 'all')
import nuxt_plugin_multiTabStateclient_e8559486 from 'nuxt_plugin_multiTabStateclient_e8559486' // Source: ../plugins/multiTabState.client.js (mode: 'client')
import nuxt_plugin_vuedatepicker_19e66559 from 'nuxt_plugin_vuedatepicker_19e66559' // Source: ../plugins/vue-datepicker (mode: 'client')
import nuxt_plugin_mixins_5013a1f0 from 'nuxt_plugin_mixins_5013a1f0' // Source: ../plugins/mixins (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"script":[{"src":"\u002Ftcf.js"},{"src":"\u002FloleData.js","env":"production"},{"src":"https:\u002F\u002Fjs.afterpay.com\u002Fafterpay-1.x.js","id":"afterpay-placement-script","data-min":"0.04","data-max":"2000.00","async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TZPKS63')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"},{"name":"msapplication-TileColor","content":"#da532c"},{"name":"msapplication-config","content":"\u002Ffavicon\u002Fbrowserconfig.xml"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Ffavicon\u002Fapple-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Ffavicon\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Ffavicon\u002Fsafari-pinned-tab.svg","color":"#5bbad5"},{"rel":"shortcut icon","href":"\u002Ffavicon\u002Ffavicon.ico"},{"rel":"shortcut icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon-precomposed","href":"\u002Fapple-touch-icon-precomposed.png"},{"rel":"apple-touch-icon-120x120","href":"\u002Fapple-touch-icon-120x120.png"},{"rel":"apple-touch-icon-120x120-precomposed","href":"\u002Fapple-touch-icon-120x120-precomposed.png"},{"rel":"apple-touch-icon-152x152","href":"\u002Fapple-touch-icon-152x152.png"},{"rel":"apple-touch-icon-152x152-precomposed","href":"\u002Fapple-touch-icon-152x152-precomposed.png"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TZPKS63?id=GTM-TZPKS63&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_5c8df442 === 'function') {
    await nuxt_plugin_sentryserver_5c8df442(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_6bff9457 === 'function') {
    await nuxt_plugin_sentryclient_6bff9457(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_62348685 === 'function') {
    await nuxt_plugin_plugin_62348685(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_1417d418 === 'function') {
    await nuxt_plugin_portalvue_1417d418(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin5762e1e4_ac87bedc === 'function') {
    await nuxt_plugin_templatesplugin5762e1e4_ac87bedc(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_526e3a9e === 'function') {
    await nuxt_plugin_gtm_526e3a9e(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_61491a0a === 'function') {
    await nuxt_plugin_recaptcha_61491a0a(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_76d29ac3 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_76d29ac3(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_3576e362 === 'function') {
    await nuxt_plugin_dayjsplugin_3576e362(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_6d0cd680 === 'function') {
    await nuxt_plugin_pluginutils_6d0cd680(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_1331c3cb === 'function') {
    await nuxt_plugin_pluginrouting_1331c3cb(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_5ee898f8 === 'function') {
    await nuxt_plugin_pluginmain_5ee898f8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_ad9eddca === 'function') {
    await nuxt_plugin_axios_ad9eddca(app.context, inject)
  }

  if (typeof nuxt_plugin_moduleplugin3f4c7f02_60e2780e === 'function') {
    await nuxt_plugin_moduleplugin3f4c7f02_60e2780e(app.context, inject)
  }

  if (typeof nuxt_plugin_klaviyoevents_593d8433 === 'function') {
    await nuxt_plugin_klaviyoevents_593d8433(app.context, inject)
  }

  if (typeof nuxt_plugin_googleanalyticsevents_5d1e23c4 === 'function') {
    await nuxt_plugin_googleanalyticsevents_5d1e23c4(app.context, inject)
  }

  if (typeof nuxt_plugin_gtmevents_3d4af65c === 'function') {
    await nuxt_plugin_gtmevents_3d4af65c(app.context, inject)
  }

  if (typeof nuxt_plugin_fbevents_46c91c94 === 'function') {
    await nuxt_plugin_fbevents_46c91c94(app.context, inject)
  }

  if (typeof nuxt_plugin_imgplaceholder_7a19279a === 'function') {
    await nuxt_plugin_imgplaceholder_7a19279a(app.context, inject)
  }

  if (typeof nuxt_plugin_lazyload_af447860 === 'function') {
    await nuxt_plugin_lazyload_af447860(app.context, inject)
  }

  if (typeof nuxt_plugin_index_6c73db4f === 'function') {
    await nuxt_plugin_index_6c73db4f(app.context, inject)
  }

  if (typeof nuxt_plugin_components_fa5dd412 === 'function') {
    await nuxt_plugin_components_fa5dd412(app.context, inject)
  }

  if (typeof nuxt_plugin_shopify_62048410 === 'function') {
    await nuxt_plugin_shopify_62048410(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4345260a === 'function') {
    await nuxt_plugin_vuelidate_4345260a(app.context, inject)
  }

  if (typeof nuxt_plugin_googlemaps_ab35f716 === 'function') {
    await nuxt_plugin_googlemaps_ab35f716(app.context, inject)
  }

  if (typeof nuxt_plugin_googleapi_2ec9487c === 'function') {
    await nuxt_plugin_googleapi_2ec9487c(app.context, inject)
  }

  if (typeof nuxt_plugin_location_6466e52b === 'function') {
    await nuxt_plugin_location_6466e52b(app.context, inject)
  }

  if (typeof nuxt_plugin_customsentry_4a274bf6 === 'function') {
    await nuxt_plugin_customsentry_4a274bf6(app.context, inject)
  }

  if (typeof nuxt_plugin_searchspring_c00bb7aa === 'function') {
    await nuxt_plugin_searchspring_c00bb7aa(app.context, inject)
  }

  if (typeof nuxt_plugin_redisclient_703602d3 === 'function') {
    await nuxt_plugin_redisclient_703602d3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_multiTabStateclient_e8559486 === 'function') {
    await nuxt_plugin_multiTabStateclient_e8559486(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedatepicker_19e66559 === 'function') {
    await nuxt_plugin_vuedatepicker_19e66559(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_5013a1f0 === 'function') {
    await nuxt_plugin_mixins_5013a1f0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
